import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;

  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: GmarketSansMedium, sans-serif;
  font-size: 20px;
  color: #333;
`;
